// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"c0529071","70":"32d97c02","71":"1673176e","195":"cda2ed7a","293":"cf92550a","349":"83ece0ad","360":"3cf1daa7","419":"7b925281","606":"df538490","621":"3884396f","870":"898e2e3d"}[chunkId] + ".chunk.js";
};